<template>
    <div class="common_footer">
        {{$t('home.remark')}}
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.common_footer {
    width: 100%;
    height: 30px;
    line-height:30px;
    background: #000000;
    font-family: PingFangSC-Regular;
    font-size: 10px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
}
</style>